// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".annual-education-trend-card .customCardbody {\n  padding-top: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
